module.exports = __webpack_public_path__ + "img/product-one-img.121dc24c.png";